import { Button } from "@mds/react-components";

export { Button };
export type { IButtonProps } from "@mds/react-components";
